import { Seo } from "@/components/Seo";

const NOINDEX_PREFIXES = ["/dashboard", "/compte", "/admin", "/nouveau-dossier", "/call/", "/profil/"];

/** noindex sur les routes privées / session (complète robots.txt). */
export default function PrivateRouteSeo({ pathname }) {
  const path = pathname || "/";
  const blocked = NOINDEX_PREFIXES.some((p) => path === p || path.startsWith(p));
  if (!blocked) return null;
  return <Seo robots="noindex, nofollow" title="Espace membre" canonicalPath={path} />;
}
